var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEtrFileUploadIconBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#FFE7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.125 6.91797C9.91789 6.91797 9.75 7.08586 9.75 7.29297V24.543C9.75 24.7501 9.91789 24.918 10.125 24.918H22.875C23.0821 24.918 23.25 24.7501 23.25 24.543V15.543C23.25 14.0932 22.0747 12.918 20.625 12.918H19.125C18.0895 12.918 17.25 12.0785 17.25 11.043V9.54297C17.25 8.09322 16.0747 6.91797 14.625 6.91797H10.125ZM20.625 11.418C21.2309 11.418 21.8063 11.5486 22.3246 11.7833C22.411 11.8224 22.5044 11.7345 22.4639 11.6488C21.6474 9.92004 20.2479 8.52058 18.5192 7.70405C18.4334 7.66356 18.3456 7.75701 18.3847 7.84336C18.6194 8.36163 18.75 8.93704 18.75 9.54297V11.043C18.75 11.2501 18.9179 11.418 19.125 11.418H20.625ZM10.125 5.41797H14.625H15C20.3848 5.41797 24.75 9.78319 24.75 15.168V15.543V24.543C24.75 25.5785 23.9105 26.418 22.875 26.418H10.125C9.08947 26.418 8.25 25.5785 8.25 24.543V7.29297C8.25 6.25743 9.08947 5.41797 10.125 5.41797ZM19.8246 16.3435C20.0653 16.0065 19.9873 15.538 19.6502 15.2973C19.3132 15.0565 18.8447 15.1346 18.604 15.4717L15.6158 19.6552C15.5798 19.7055 15.5074 19.7115 15.4637 19.6678L14.0303 18.2344C13.7374 17.9415 13.2626 17.9415 12.9697 18.2344C12.6768 18.5273 12.6768 19.0022 12.9697 19.2951L15.1125 21.4379C15.2684 21.5938 15.485 21.6732 15.7047 21.655C15.9244 21.6369 16.125 21.5229 16.2532 21.3435L19.8246 16.3435Z",
    fill: "#A614B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtrFileUploadIconBadge);
export default __webpack_public_path__ + "static/media/etr-file-upload-Icon-Badge.4df24d63755da97f5751a40df6b718b4.svg";
export { ForwardRef as ReactComponent };